import { FormControl, Validators } from '@angular/forms';
import { ProductAddon } from '@teem/models/product-addon';

export class ProductAddonForm {
	uuid = new FormControl();
	id = new FormControl();
	modifier_id = new FormControl('', [Validators.required]);
	min = new FormControl(0, [Validators.required, Validators.max(99000000)]); 
	max = new FormControl(0, [Validators.required, Validators.max(99000000)]); 
	modifier_option_id = new FormControl([], Validators.required);

	constructor(addons: ProductAddon) {
		if (addons.uuid)
			this.uuid.setValue(addons.uuid);

		this.modifier_id.setValue(addons.modifier_id);
		this.id.setValue(addons.id);
		this.min.setValue(addons.min);
		this.max.setValue(addons.max);
		this.modifier_option_id.setValue(addons.modifier_option_id || []);
	}
}
